import { useAppSelector } from '~/redux/hooks'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import USCurriculumToggle from '~/curriculum/components/USCurriculumToggle'
import { useGetUserChosenCurriculumCountryCode } from '~/curriculum/hooks/useGetCurriculumCountryCode'
import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'
import { selectGradeContent, selectSelectedSubdivision } from '~/curriculum/slice/curriculum.slice'

import CurriculumFooter from './CurriculumFooter'
import CurriculumHeader from './CurriculumHeader'
import { Quarters } from './Quarters'

export default function CurriculumOverview({
  isJuniorGradeOnboarding,
}: {
  isJuniorGradeOnboarding?: boolean
}): React.ReactElement {
  const gradeData = useAppSelector(selectGradeContent)
  const isUSACurriculum = useGetUserChosenCurriculumCountryCode() === CurriculumCountryCodes.USA
  const hasMultipleSubdivisions = gradeData?.gradeSubdivisions?.length > 1
  const selectedSubdivision = useAppSelector(selectSelectedSubdivision(gradeData?.gradeLevel ?? 1)) ?? 0

  return (
    <div className="relative">
      {gradeData.isJuniorMathGrade && (
        <div className="fixed left-0 top-4 w-screen h-screen">
          <ResponsiveImage
            fit="cover"
            height={100}
            imageClassName="object-cover h-screen w-screen"
            srcKey="gamification/starry-backgound.svg"
            width={100}
          />
        </div>
      )}
      <div className="w-full space-y-2 relative -mt-4">
        <CurriculumHeader
          shouldShowBackButton
          showIntroductionSubtitle={isJuniorGradeOnboarding}
          title={gradeData.title}
        />
        {isUSACurriculum && hasMultipleSubdivisions && (
          <USCurriculumToggle
            gradeLevel={gradeData.gradeLevel}
            quarterList={gradeData.gradeSubdivisions}
            selectedSubdivision={selectedSubdivision}
          />
        )}
        <Quarters
          isQuarteredCurriculum={gradeData.hasSubdivision}
          isUSACurriculum={isUSACurriculum}
          quarterList={gradeData.gradeSubdivisions}
          selectedSubdivision={selectedSubdivision}
        />
        {!isJuniorGradeOnboarding && <CurriculumFooter />}
      </div>
    </div>
  )
}
